export let marquee = {
	current: 0,
	target: "",
	galleryTarget: "",
	galleryList: 0,
	galleryCurrent: 0,
	init: function(){
		let $marqueeBlock = document.querySelector("[data-marquee]");
		if( $marqueeBlock ){
			marquee.target = $marqueeBlock.querySelector("p");
			marquee.move();
		}
		let $gallery = document.querySelector("#gallery");
		if( $gallery ){
			marquee.galleryTarget = $gallery.querySelector("ul");
			let lists = marquee.galleryTarget.querySelectorAll("li");
			//marquee.galleryList
			lists.forEach( (li) => {
				const clonedLi = li.cloneNode(true);
				marquee.galleryTarget.appendChild(clonedLi);
			});
			marquee.galleryList = marquee.galleryTarget.querySelectorAll("li");
			marquee.galleryMove();
		}
	},
	move: function(){
		marquee.current -= 1;
		marquee.target.style.backgroundPosition = `${marquee.current}px 0`;
		setTimeout(function(){
			marquee.move();
		}, 10);
	},
	galleryMove: function(){
		marquee.galleryCurrent -= 1;
		
		let w = marquee.galleryList[0].clientWidth;
		let computedStyle = window.getComputedStyle(marquee.galleryList[0]);
		let ml 	= computedStyle.getPropertyValue("margin-left").replace("px", "");
		let wm 	= w + parseInt(ml);
		let allW = (wm*marquee.galleryList.length)/-2;
		//console.log(allW);
		if( marquee.galleryCurrent < allW){
			marquee.galleryCurrent = 0;
		}
		marquee.galleryTarget.style.transform = `translate3d(${marquee.galleryCurrent}px, 0px, 0px)`;
		setTimeout(function(){
			marquee.galleryMove();
		}, 10);
	}
}